<template >
  <div>
    <!-- <button
      style="width: 120px"
      @click="testVoucher = true"
      class="btn btn-outline-primary"
    >
      تست واچر
    </button>
    <div v-html="onTickets.tickets[0].voucher"></div> -->

    <div id="action">
      <div class="btn-group btn-group-justified">
        <!-- <button  class="btn btn-outline-primary">دانلود</button> -->
        <button
          style="width: 120px"
          @click="print"
          class="btn btn-outline-primary"
        >
          چاپ
        </button>
        <button style="width: 120px" class="btn btn-outline-primary">
          صفحه اصلی
        </button>
      </div>
    </div>
    <div style="font-size: 10pt !important;
        font-family: Tahoma !important;" v-show="noneDisplay" ref="tickets" id="tickets">
      <div style="font-size: 10pt !important;
        font-family: Tahoma !important; " id="hotel-ticket">
        <div
          style="
            direction: rtl;
            display: flex;
            border: 1px solid;
            padding: 20px;
          "
        >
          <div style="width: 25%">
            <img
              width="160"
              height="50"
              src="https://dariushgroup.com/img/pdk_logo_small.png"
            />
          </div>
          <div style="width: 75%; display: grid; text-align: left">
            <label
              >PMS:
              <span>{{ onTickets.tickets[0].hotelReserveNumber }}</span></label
            >
            <!-- <label>Reservation Number: <span>{{onTickets.tickets[0].reserveNumber}}</span></label> -->
            <label
              >Issue Date:
              <span>{{ onTickets.tickets[0].shamsiDate }}</span></label
            >
          </div>
        </div>
        <div style="
            font-size: 10pt !important;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 6px !important;
            text-align: center !important;
            margin-top: 5px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          ">هتل</div>
        <div style="display: flex; border: 1px solid; padding: 20px">
          <div
            style="
              flex-wrap: wrap;
              margin-right: -15px;
              margin-left: -15px;
              direction: rtl;
              text-align: initial;
              display: flex;
              width: 100%;
            "
            id="hotel"
          >
            <strong style="margin-bottom: 20px; margin-right: 1%; width: 100%">
              {{ hotelSummary.name }}</strong
            >

            <label style="margin-right: 1%; width: 100%"
              ><strong>نشانی :</strong> {{ hotelSummary.address }}</label
            >
            <br />
            <div style="display: contents" id="time">
              <label style="margin-right: 1%"
                ><strong>تاریخ ورود:</strong>
                {{ onTickets.tickets[0].shamsiDepartureDate }}</label
              >

              <label style="margin-right: 6%"
                ><strong>تاریخ خروج:</strong>
                {{ onTickets.tickets[0].shamsiReturnDate }}</label
              >
            </div>
            <br />
            <div
              style="
                width: 100%;
                padding-right: 10%;
                padding-left: 10%;
                margin-right: auto;
                margin-left: auto;
                direction: rtl;
                text-align: initial;
                margin-top: 8px;
              "
            >
              <table
                style="
                  width: 100%;
                  margin-bottom: 1rem;
                  color: #212529;
                  border-collapse: collapse;
                "
              >
                <tbody>
                  <tr style="border-bottom: 1px solid">
                    <td>اتاق</td>
                    <td>بزرگسال</td>
                    <td>کودک</td>
                    <td></td>
                  </tr>
                  <tr
                    v-for="(room, index) in onTickets.roomDetails"
                    :key="index"
                  >
                    <td>{{ room.hotelRoomTypeTitle }}</td>
                    <td>{{ room.roomAdult }}</td>
                    <td>{{ room.roomChild }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div style="
            font-size: 10pt !important;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 6px !important;
            text-align: center !important;
            margin-top: 5px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          ">مشخصات رزرو کننده و مسافرین</div>

        <div
          style="
            direction: rtl;
            text-align: initial;
            border: 1px solid;
            padding: 20px;
          "
        >
          <label style="margin-right: 1%; width: 100%"
            ><span>نام و نام خانوادگی :</span
            >{{ onTickets.tickets[0].customerName }}
            {{ onTickets.tickets[0].customerLastName }}</label
          >
          <br />
          <div style="margin-right: 1%; display: contents" id="time">
            <label style="margin-right: 1%"
              ><span>شماره تماس:</span> {{ onTickets.tickets[0].phone }}</label
            >

            <label style="margin-right: 6%"
              ><span>پست الکترونیک:</span>
              {{ onTickets.tickets[0].email }}</label
            >
          </div>
          <br />
          <label style="margin-right: 1%"
            ><span>نشانی:</span> {{ onTickets.tickets[0].address }}</label
          >
          <br />
          <label style="margin-right: 1%"
            ><span>مشخصات مسافرین:</span>
            <div
              style="margin-right: 1%; display: contents"
              v-for="(passenger, index) in onTickets.passengers"
              :key="index"
            >
              <span>
                {{ passenger.passengerName }} &nbsp;
                {{ passenger.passengerLastName }}
                <span style="font-size: 9pt"
                  >({{ passenger.pasportId }} ,{{ passenger.birthDateShamsi }} )
                </span></span
              >
              <span v-if="index !== onTickets.passengers.length - 1">-</span>
            </div>
          </label>

          <div
            style="
              direction: rtl;
              margin-top: 3px;
              text-align: initial;
              font-size: 10pt;
              padding: 15px 5px 5px 5px;
              background: #f5faf7;
            "
          >
          <div>
            <strong style="margin-left: 5px">درخواست مسافر:</strong>
            <span>{{ onTickets.tickets[0].customerRequest }}</span>
            </div>
             <div
            v-if="onTickets.hotelDetail.hotelDetail.transfer"
            style="
              direction: rtl;
              text-align: initial;
              font-size: 10pt;
              padding: 15px 5px 0px 5px;
              background: #f5faf7;
            "
            ><strong>اطلاعات ترانسفر:</strong>
            <div style="margin-right: 1%; display: contents">
              <label> وسیله سفر - <span>هواپیما</span></label>
              <label style="margin-right: 1%">
                تاریخ سفر -
                <span>{{ onTickets.tickets[0].departureDateStr }}</span></label
              >
              <label style="margin-right: 1%">
                ساعت سفر -
                <span>{{ onTickets.tickets[0].departuretimeStr }}</span></label
              >
              <label style="margin-right: 1%">
                توضیحات سفر -
                <span
                  >{{ onTickets.tickets[0].pnr }}
                  {{ onTickets.tickets[0].flightNumber }}</span
                ></label
              >
              <label style="margin-right: 1%">
                تاریخ برگشت -
                <span>{{ onTickets.tickets[0].returnDateStr }}</span></label
              >
              <label style="margin-right: 1%">
                ساعت برگشت -
                <span>{{ onTickets.tickets[0].returntimeStr }}</span></label
              >
              <label style="margin-right: 1%">
                توضیحات برگشت -
                <span
                  >{{ onTickets.tickets[onTickets.tickets.length-1].pnr }}
                  {{ onTickets.tickets[onTickets.tickets.length-1].flightNumber }}</span
                ></label
              >
            </div>
          </div>
          </div>

         
        </div>

        <div style="
            font-size: 10pt !important;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 6px !important;
            text-align: center !important;
            margin-top: 5px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          ">قوانین و مقررات</div>
        <div
          style="
            direction: rtl;
            border: 1px solid black;
            padding: 6px;
            text-align: right;
          "
        >
          <div
            style="margin-bottom: 50px; margin-right: 1%; display: contents"
            id="time"
          >
            <label style="margin-right: 1%"
              ><span>زودترین ساعت تحویل اتاق:</span>
              {{ hotelDetail.checkInTime.substring(0, 5) }}</label
            >

            <label style="margin-right: 3%"
              ><span>دیرترین ساعت تخلیه اتاق :</span>
              {{ hotelDetail.checkOutTime.substring(0, 5) }}</label
            >
            <label style="margin-right: 3%"
              ><span>مهلت کنسلی رزرو قبل از ورود :</span
              >{{ hotelDetail.cancelTerm }}<span>روز</span>
            </label>
          </div>
          <br />
          <strong style="margin-right: 1%">میهمان گرامی : </strong>
          <p
            v-html="hotelDetail.hotelPolicy"
            style="margin-right: 1%; font-size: 9pt !important"
          ></p>
        </div>

        <div style="
            font-size: 10pt !important;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 6px !important;
            text-align: center !important;
            margin-top: 5px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          ">شرایط لغو</div>
        <div style="border: 1px solid black; padding: 6px; text-align: right">
          <p
            v-html="hotelDetail.cancelPolicy"
            style="direction: rtl; font-size: 9pt !important"
          ></p>
        </div>
        <div style="direction: rtl">
          <label style="float: right; direction: rtl; font-size: 9pt"
            ><span>کاربر ثبت کننده :</span
            >{{ onTickets.tickets[0].userName }}</label
          >
          <label style="float: left; direction: rtl; font-size: 9pt">{{
            onTickets.tickets[0].reserveNumber
          }}</label>
        </div>
        <!-- <div  class="pass"> خدمات رایگان هتل </div>
<div  style="border: 1px solid black;padding: 6px;text-align: right;">
<p style="font-size: 15pt !important;">
   ﺗﺮاﻧﺴـﻔﺮ ﻓﺮودﮔﺎﻫﯽ رﻓﺖ و ﺑﺮﮔﺸﺖ - ﺻﺒﺤﺎﻧﻪ(ﻣﻨﻮی ﻣﺤﺪود) - اﯾﻨﺘﺮﻧﺖ - ﺳﺮوﯾﺲ ﭼﺎی داﺧﻞ اﺗﺎق - اﺳﺘﺨﺮ روﺑﺎز ﺑﺮای آﻗﺎﯾﺎن - زﻣﯿﻦ ﺗﻨﯿﺲ - اﺳﺘﺨﺮ روﺑﺎز ﺑﺎﻧﻮان – ﻋﺼﺮاﻧﻪ(وﯾﮋه اﺗﺎق ﻟﻮﮐﺲ درﯾﺎ و ﺳﻮﺋﯿﺖ ﻫﺎی ﻟﻮﮐﺲ)
</p>
</div> -->

        <!-- <div  class="pass"> خدمات جانبی هتل </div>
<div  style="border: 1px solid black;padding: 6px;text-align: right;">
<p style="font-size: 15pt !important;">
 اﺟﺎره ﻣﺎﺷﯿﻦ - ﻏﻮاﺻﯽ - ﻣﺎﺳﺎژ ﺗﺎﯾﻠﻨﺪی - دوﭼﺮﺧﻪ ﺳﻮاری
</p>
</div> -->

      </div>
     
      <div style = "display:block; clear:both; page-break-after:always;"></div>
      <div style="font-size: 10pt !important;
        font-family: Tahoma !important; " v-for="(passenger, index) in onTickets.passengers" :key="index">
        <div
          style="
            direction: rtl;
            display: flex;
            border: 1px solid;
          padding: 10px 15px 2px 15px;
          "
        >
          <div style="width: 25%">
            <img
              width="160"
              height="50"
              src="https://dariushgroup.com/img/pdk_logo_small.png"
            />
          </div>
          <div style="width: 75%; display: grid; text-align: left">
            <!-- <label>PNR: <span>S6M97</span></label> -->
            <label
              >PNR:
              <span
                >{{ onTickets.tickets[0].departureFlightPNR }} -
                {{ onTickets.tickets[0].returnFlightPNR }}</span
              ></label
            >
            <label
              >Issue Date:
              <span>{{ onTickets.tickets[0].shamsiDate }}</span></label
            >
          </div>
        </div>

        <div
          style="
            font-size: 10pt !important;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 6px !important;
            text-align: center !important;
            margin-top: 5px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          "
        >
          مشخصات مسافر
        </div>

        <div
          style="
            direction: rtl;
            text-align: initial;
            border: 1px solid black;
            padding: 6px;
            text-align: center;
          "
        >
          <table
            style="font-size: 10pt !important; margin: 15px auto; width: 66%"
          >
            <tbody>
              <tr  style="border-bottom: 1px solid">
                <td>نام و نام خانوادگی</td>
                <td>شماره پاسپورت / کدملی</td>
                <td>تاریخ تولد</td>
              </tr>

              <tr>
                <td>
                  {{ passenger.enName }} &nbsp;
                  {{ passenger.enLastName }}
                </td>
                <td>
                  {{ passenger.pasportId }}
                </td>
                <td>{{ passenger.birthDateShamsi }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="
            font-size: 10pt !important;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 6px !important;
            text-align: center !important;
            margin-top: 5px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          ">مشخصات پرواز</div>
        <div style="border: 1px solid black; padding: 6px; text-align: center">
          <div
            style="padding-top: 1%"
            v-for="(flight, index) in onTickets.flightTickets"
            :key="index"
          >
            <div
              style="display: flex; direction: rtl; margin-right: 10%"
              v-if="passenger.pasportId === flight.pasportId"
            >
              <div>
                <img :src="getAirLineLogoUrl(flight.airlineId)" />
              </div>
              <table
              
                style="  color: #212529;
                  border-collapse: collapse;font-size: 10pt !important; margin: 25px 0px; width: 80%"
              >
                <tbody>
                  <tr style="border-bottom: 1px solid #000 !important">
                    <td>پرواز</td>
                    <td>مبدا</td>
                    <td>مقصد</td>
                    <td>زمان حرکت</td>
                    <td>ساعت حرکت</td>
                    <td>شماره بلیط</td>
                  </tr>

                  <tr>
                    <td>{{ flight.flightNumber }}</td>
                    <td>{{ flight.originLocation }}</td>
                    <td>{{ flight.destinationLocation }}</td>
                    <td>{{ flight.flightDateShamsi }}</td>
                    <td>{{ flight.flighttimeStr }}</td>
                    <td>{{ flight.ticketNumber }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div style="
            font-size: 10pt !important;
            border-left: 1px solid black !important;
            border-right: 1px solid black !important;
            border-top: 1px solid black !important;
            padding: 6px !important;
            text-align: center !important;
            margin-top: 5px !important;
            box-shadow: inset 0 0 0 1000px rgb(231, 231, 231) !important;
            color: black !important;
          ">قوانین و مقررات</div>
        <div
          style="
            direction: rtl;
            border: 1px solid black;
            padding: 6px;
            text-align: right;
          "
        >
          <p style="direction: rtl; font-size: 10pt !important">
            در ﻫﻨﮕﺎم ﻣﺮاﺟﻌﻪ ﺑﻪ ﻓﺮودﮔﺎه ﺑﻪ ﻫﻤﺮاه داﺷـﺘﻦ ﺑﻠﯿﺖ و ﯾﺎ ﺷﻤﺎره ﺳﺮﯾﺎل
            ﺑﻠﯿﺖ ﺗﻤﺎﻣﯽ ﻣﺴﺎﻓﺮان، ﺑﻪ ﻫﻤﺮاه ﮐﺎرت ﻣﻠﯽ (اتباع ایرانی) و ﯾﺎ ﮔﺬرﻧﺎﻣﻪ
            (اﺗﺒﺎع ﺧﺎرﺟﯽ) اﻟﺰاﻣﯽ است.
          </p>
          <ul style="direction: rtl">
            <li>
              ﺗﻤﺎﻣﯽ » ﭘﺮوازﻫﺎی داﺧﻠﯽ ﺷﺮﮐﺖ ﻫﻮاﭘﯿﻤﺎﯾﯽ زاﮔﺮس« در ﺗﺮﻣﯿﻨﺎل ﺷﻤﺎره ﯾﮏ
              ﻓﺮودﮔﺎه ﺑﯿﻦ اﻟﻤﻠﻠﯽ ﻣﻬﺮآﺑﺎد اﻧﺠﺎم ﻣﯽ ﺷﻮد
            </li>
            <li>ﺑﺎرﻣﺠـﺎز ﺑﺮای ﻣﺴﺎﻓﺮان ﭘﺮوازﻫﺎی داﺧﻠﯽ 20» ﮐﯿﻠﻮﮔﺮم« ﻣﯽ باشد.</li>
            <li>
              ﺣﻀﻮر ﻣﺴـﺎﻓﺮ در ﭘﺮوازﻫﺎی داﺧﻠﯽ 2 ﺳﺎﻋﺖ ﻗﺒـﻞ از ﭘﺮواز اﻟﺰاﻣﯿﺴﺖ در
              ﺻﻮرت ﺧﺮﯾـﺪ ﺑﻠﯿـﻂ ﺗﻮﺳﻂ دﻓﺎﺗﺮ ﺧـﺪﻣﺎت ﻣﺴﺎﻓﺮﺗﯽ و ﺻـﺪور ﺑﻠﯿﻂ ﻣﺘﻔﺮﻗﻪ
              ﺗﻮﺳﻂ آﻧﻬﺎ، ﺷـﺮﮐﺖ ﻫﻮاﭘﯿﻤﺎﯾﯽ زاﮔﺮس ﻫﯿﭽﮕﻮﻧﻪ ﻣﺴـﺌﻮﻟﯿﺘﯽ در ﻗﺒﺎل ﻋﺪم
              ﭘﺬﯾﺮش ﻣﺴﺎﻓﺮ ﻧﺨﻮاﻫﺪ داشت..
            </li>
          </ul>
          <strong>استرداد وجه :</strong>
          <p style="direction: rtl">
            وﺟﻪ اﺳﺘﺮداد ﺑﻠﯿﺖ ﻓﻘﻂ ﺑﻪ ﺷﻤﺎره ﮐﺎرت ﻣﺴﺎﻓﺮ ﻣﺴﺘﺮد ﻣﯽ ﮔﺮدد. ﻟﻄﻔﺎ ﺑﺮای
            ﮐﺴﺐ اﻃﻼﻋﺎت ﺑﯿﺸﺘﺮ و آﮔﺎﻫﯽ از ﺳﺎﯾﺮ ﻣﻘﺮرات ﺑﻪ وب ﺳﺎﯾﺖ رﺳـﻤﯽ ﺷـﺮﮐﺖ
            ﻫﻮاﭘﯿﻤﺎﯾﯽ زاﮔﺮس ﻣﺮاﺟﻌﻪ ﻓﺮﻣﺎﺋﯿـﺪ.
          </p>
        </div>
        <footer>
          <div style="direction: rtl">
            <label style="float: right; direction: rtl; font-size: 9pt"
              ><span>کاربر ثبت کننده :</span
              >{{ onTickets.tickets[0].userName }}</label
            >
            <label style="float: left; direction: rtl; font-size: 9pt">{{
              onTickets.tickets[0].reserveNumber
            }}</label>
          </div>
        </footer>
        <div v-if="index !== passenger.length - 1" style = "display:block; clear:both; page-break-after:always;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Store from "../../views/tour/store/index";
export default {
  name: "TicketAction",
store: Store,
  components: {},
  props: {
    tickets: { type: Object, default: () => ({}) },
  },
  data: () => ({
    testVoucher: false,
    voucherNumber: 0,
    noneDisplay: false,
    hotelDetail: {},
    hotelSummary: {},
  }),
  created() {
   
    this.voucherNumber = this.tickets.tickets[0].voucherNumber;
  },
  computed: {
    onTickets() {
      this.hotelDetail = this.tickets.hotelDetail.hotelDetail;
      this.hotelSummary = this.tickets.hotelDetail.hotelSummary;

     
      return (this.tickets = this.tickets);
    },
  },
  methods: {
    getAirLineLogoUrl(name) {
      return "https://dariushgroup.com/img/airlines/" + name + ".png";
    },
    print() {
      const localOptions = {
        styles: [
          "https://dariushgroup.com/css/bootstrap.css",
          "https://dariushgroup.com/css/printTicket.css",
        ],
      };
      this.$htmlToPaper("tickets", () => {
        console.warn("done landscape");
      });
    },
  },
  async mounted() {


//  console.log('this tickets' , this.tickets);
debugger
    var voucher = this.$refs.tickets.innerHTML;

    if (voucher) {
      var request = {
        voucherNumber: this.voucherNumber,
        voucher: voucher,
      };
      var res = await this.$store.dispatch("unauthorized/CreateVoucher", request);
      if (res) {
        if (res.result == 0) {
          console.log("voucher error ", res.result);
        }
      } else {
        console.log("voucher error ");
      }
    }
  },
  //    mounted() {
  //     debugger
  //     console.log('this.voucherNumber',this.voucherNumber);

  //     console.log('dssdasdasdas dasdasdasd',this.$refs['tickets']);
  //     var voucher = this.$refs['tickets'];
  // if (voucher) {

  //     var request = {
  //      voucherNumber: this.voucherNumber,
  //      voucher: this.$refs['tickets']
  //     }
  //     var res =  this.$store.dispatch("Book/CreateVoucher", request);
  //       if (res) {
  //        console.log('voucher res ', res);
  //       }
  // }

  //   }
};
</script>

<style lang="scss" scoped>
#action {
  text-align: center;
  margin-top: 20px;
}
</style>